import { playDeliveryTake, playUiClickB } from '../../assets/preloadSounds';
import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { NavBarTab } from '../components/composite/nav/nav_bar/NavBar';
import type { GiantId } from './giants/giantPositions';
import {
  clampCamera,
  mapArrowNudge,
  type MapCamera,
  type MapScreenModel,
} from './MapScreenModelScreen';

export class MapScreenController {
  constructor(private readonly model: MapScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    this.model.setCamera((prev) => {
      const { dx, dy } = mapArrowNudge(prev, direction, this.model.viewSize);
      return { ...prev, x: prev.x + dx, y: prev.y + dy };
    });
  };

  handlePan = (camera: MapCamera) => {
    this.model.setCamera(clampCamera(camera, this.model.viewSize));
  };

  handleTabChange = (tab: NavBarTab) => {
    this.model.onTabChange?.(tab);
  };

  handleTakeDelivery = (giantId: GiantId, orderIndex: number) => {
    playDeliveryTake();
    this.model.onTakeDelivery?.(giantId, orderIndex);
  };

  handleOpenTickets = () => {
    playUiClickB();
    this.model.onOpenTickets?.();
  };

  handleOpenRating = () => {
    playUiClickB();
    this.model.onOpenRating?.();
  };

  handleOpenPlayerLevel = () => {
    playUiClickB();
    this.model.onOpenPlayerLevel?.();
  };
}
